export const redirectPost = (url, data) => {
  let form = document.createElement('form')
  document.body.appendChild(form)
  form.method = 'post'
  form.action = url
  form.target = '_top'
  for (var name in data) {
      var input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = JSON.stringify(serialize(data[name]))
      form.appendChild(input)
  }
  form.submit()
}

export const redirectGet = (url, { includeAnswers, data }) => {
  const fullUrl = new URL(url)

  if (includeAnswers && data) {
    for (var name in data) {
      fullUrl.searchParams.append(name, JSON.stringify(serialize(data[name])))
    }
  }

  let link = document.createElement('a')
  document.body.appendChild(link)
  link.target = '_top'
  link.href = fullUrl
  link.click()
}


const serialize = (value) => {
  if (value && value.id) {
    let response = { id: value.id }
    if (value.email) response.email = value.email
    if (value.name) response.name = value.name

    return response
  }

  return value
}
